import { PlayerHookType } from '@cbsinteractive/avia-js';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { AbstractAviaPlayerHook } from 'tag/ts/tag/player/adapters/avia/hooks/AbstractAviaPlayerHook';
export class AviaPlayerPremiumAudioHook extends AbstractAviaPlayerHook {
    hookType = PlayerHookType.RESPONSE;
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaPlayerPremiumAudioHook'
        });
        this.tagEventsHandler(this.#onTagEvent, [
            TagEvent.ON_CREATE_PLAYER_SUCCESS
        ]);
    }
    #onTagEvent = (event) => {
        switch (event?.type) {
            case TagEvent.ON_CREATE_PLAYER_SUCCESS:
                this.removeTagEventsHandler(this.#onTagEvent, this.tag.eventDispatcher, [TagEvent.ON_CREATE_PLAYER_SUCCESS]).then((data) => {
                    this.registerHook();
                });
                break;
        }
    };
    callback = (context) => {
        const response = context.value;
        const isLive = this.tag?.params?.CONTENT?.apiMetadata?.[0]?.isLive || this.tag?.params?.CONTENT?.resource?.metadata?.isLive;
        if (response?.url.includes('.mpd') && !isLive) {
            try {
                const xml = new DOMParser().parseFromString(response.data, 'text/xml');
                this?.logger?.log('xml:', xml);
                const tracks = this.#pullAudioTracksFromManifest(xml);
                const ec3 = tracks?.ec3 || [];
                const aac = tracks?.aac || [];
                if (!aac.length) {
                    this?.logger?.warn('Possible issue with video manifest or loading of video manifest, length of standard audio tracks is Zero');
                    this?.logger?.log('response:', response);
                    return;
                }
                if (!this.#isPremiumAudioTracksIncomplete(aac, ec3)) {
                    this?.logger?.log('Available audio codecs match; DID NOT manipulate manifest');
                    return;
                }
                ec3.forEach((set) => {
                    set.parentNode.removeChild(set);
                });
                const serializer = new XMLSerializer();
                const updatedMpd = serializer.serializeToString(xml);
                if (updatedMpd) {
                    context.value.data = updatedMpd;
                    this?.logger?.log('Available audio codecs mismatched; removing ec3 from manifest');
                }
                else {
                    this?.logger?.warn('There was a problem when trying to remove ec3 tracks from manifest');
                }
            }
            catch (error) {
                this?.logger?.warn(error);
            }
        }
    };
    #isPremiumAudioTracksIncomplete = (standardTracks, premiumTracks) => {
        if (!this.utils.Type.isArray(standardTracks) || !this.utils.Type.isArray(premiumTracks)) {
            return true;
        }
        this?.logger?.log('standardTracks length:', standardTracks.length);
        this?.logger?.log('premiumTracks length:', premiumTracks.length);
        if (standardTracks.length !== premiumTracks.length) {
            return true;
        }
        if (standardTracks.length === premiumTracks.length) {
            this?.logger?.log('list lengths are the same', standardTracks, premiumTracks);
        }
        let foundIncompleteTrack = false;
        standardTracks.forEach((standardTrack) => {
            if (foundIncompleteTrack)
                return;
            const standardRole = standardTrack.querySelector('Role');
            const standardLang = standardTrack.attributes?.getNamedItem('lang')?.value?.toLowerCase?.();
            if (!standardLang)
                return;
            let matchingTrack = undefined;
            premiumTracks.forEach((premiumTrack) => {
                if (!this.utils.Type.isNullOrUndefined(matchingTrack))
                    return;
                const premiumRole = premiumTrack.querySelector('Role');
                const sameRole = (!standardRole && !premiumRole) || standardRole?.isEqualNode(premiumRole);
                const premiumLang = premiumTrack.attributes?.getNamedItem('lang')?.value?.toLowerCase?.();
                const sameLanguage = standardLang === premiumLang;
                if (sameRole && sameLanguage) {
                    matchingTrack = premiumTrack;
                }
            });
            if (this.utils.Type.isNullOrUndefined(matchingTrack)) {
                this?.logger?.log('no matching track found for', standardTrack, standardRole, standardLang);
                foundIncompleteTrack = true;
                return;
            }
        });
        return foundIncompleteTrack;
    };
    #pullAudioTracksFromManifest = (manifestXML) => {
        const sets = manifestXML.querySelectorAll('AdaptationSet[contentType=audio]');
        this?.logger?.log('sets:', sets);
        const ec3 = [], aac = [];
        for (let i = 0; i < sets.length; i++) {
            (sets[i].querySelector('Representation[codecs=ec-3]')) ? ec3.push(sets[i]) : aac.push(sets[i]);
        }
        this?.logger?.log('audio tracks ec3: ', ec3);
        this?.logger?.log('audio tracks aac: ', aac);
        return {
            ec3,
            aac
        };
    };
}
